__turbopack_context__.v({
  "dFlex": "kOPfpa_dFlex",
  "newsletter": "kOPfpa_newsletter",
  "titNewsletter": "kOPfpa_titNewsletter",
  "titlePadrao": "kOPfpa_titlePadrao",
});
